import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "mdb-ui-kit/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Input, Ripple, initMDB } from "mdb-ui-kit";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useMediaQuery, useTheme } from "@mui/material";
import FooterManual from "./footerManual";
import Notes from "./header";

initMDB({ Input, Ripple, initMDB });

// Color Palette - RED and LIGHT RED THEME
const PRIMARY_RED = "#DC2626";
const DARK_RED_ACCENT = "#991B1B";
const TEXT_DARK = "#1F2937";
const TEXT_MEDIUM = "#4B5563";
const LIGHT_RED = "#FEE2E2";
const GRAY_TEXT = "#4B5563";

const PaymentCard = styled(Paper)(({ theme }) => ({
    backgroundColor: "#FFFFFF",
    border: `1px solid ${LIGHT_RED}`,
    borderRadius: "12px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    transition: "all 0.2s ease",
    '&:hover': {
        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
    }
}));

const PaymentMethodCard = styled(Box)(({ theme }) => ({
    border: `1px solid ${PRIMARY_RED}`,
    borderRadius: "10px",
    padding: theme.spacing(2),
    backgroundColor: "#FFFBFB",
    marginBottom: theme.spacing(2),
    position: "relative",
    overflow: "hidden",
    '&::before': {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "3px",
        height: "100%",
        backgroundColor: PRIMARY_RED
    }
}));

const SecurePayment = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                backgroundColor: "#FFFFFF",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Box sx={{ marginBottom: "0%" }}><Notes /></Box>
            
            {/* Banner Section */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: isMobile ? "25vh" : isTablet ? "35vh" : "50vh",
                    backgroundColor: "black",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: "hidden",
                }}
            >
                <Box
                    component="img"
                    src="/image/AllSeeModelsBackgroungCar.png"
                    alt="Amar Enterprises Vehicle Background"
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        opacity: 0.35,
                    }}
                />

                <Typography
                    sx={{
                        position: "relative",
                        color: "white",
                        fontWeight: "900",
                        textTransform: "uppercase",
                        letterSpacing: isMobile ? "1px" : isTablet ? "2px" : "4px",
                        fontSize: isMobile ? "24px" : isTablet ? "42px" : "60px",
                        zIndex: 2,
                        textShadow: "0 0 10px rgba(0,0,0,0.8)",
                        textAlign: "center",
                        lineHeight: 1.1,
                        px: "20px",
                    }}
                >
                    Payment Terms & Policy
                </Typography>
            </Box>

            {/* Main Content Container */}
            <Box 
                sx={{ 
                    flex: 1,
                    position: "relative",
                    paddingBottom: isMobile ? "60px" : isTablet ? "100px" : "150px"
                }}
            >
                <Box
                    sx={{
                        width: isMobile ? "95%" : isTablet ? "92%" : "85%",
                        backgroundColor: "#FFFFFF",
                        border: `2px solid ${LIGHT_RED}`,
                        margin: "0 auto",
                        marginTop: isMobile ? "-50px" : isTablet ? "-60px" : "-80px",
                        borderRadius: isMobile ? "12px" : isTablet ? "16px" : "20px",
                        padding: isMobile ? "20px 16px" : isTablet ? "32px 24px" : "40px 30px",
                        boxShadow: "0 15px 50px rgba(0, 0, 0, 0.12)",
                        zIndex: 10,
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* Introduction Section */}
                    <Box sx={{ textAlign: "center", marginBottom: isMobile ? "35px" : isTablet ? "45px" : "60px" }}>
                        <Typography
                            sx={{
                                fontWeight: "800",
                                color: DARK_RED_ACCENT,
                                marginBottom: isMobile ? "10px" : "12px",
                                textTransform: "uppercase",
                                fontSize: isMobile ? "18px" : isTablet ? "24px" : "32px",
                                lineHeight: 1.3,
                            }}
                        >
                            Secure, Global, and Transparent Transactions
                        </Typography>
                        <Typography
                            sx={{
                                color: GRAY_TEXT,
                                fontSize: isMobile ? "13px" : isTablet ? "14px" : "16px",
                                maxWidth: "900px",
                                margin: "0 auto",
                                lineHeight: "1.7",
                                px: isMobile ? "12px" : "0",
                            }}
                        >
                            At Amar Enterprises Co Ltd, we provide <b>transparent payment terms</b> with <b>multiple payment options</b> and <b>industry-standard security</b>. Our payment process is designed to be secure, efficient, and compliant with international standards.
                        </Typography>
                    </Box>

                    {/* 1. Accepted Payment Methods & Security */}
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            fontWeight: "bold", 
                            color: TEXT_DARK, 
                            borderBottom: `2px solid ${LIGHT_RED}`, 
                            paddingBottom: "10px", 
                            marginBottom: "20px",
                            fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
                        }}
                    >
                        <i className="fas fa-hand-holding-usd me-2" style={{ color: PRIMARY_RED }}></i>
                        1. Accepted Payment Methods & Fees
                    </Typography>

                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: isMobile ? "15px" : "20px", marginBottom: "30px" }}>

                        {/* International Bank Transfer (T/T) */}
                        <PaymentMethodCard>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
                                <Box sx={{ 
                                    backgroundColor: PRIMARY_RED,
                                    width: "36px", 
                                    height: "36px", 
                                    borderRadius: "50%", 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center" 
                                }}>
                                    <i className="fas fa-university" style={{ color: "white", fontSize: "16px" }}></i>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: "bold", color: TEXT_DARK, fontSize: isMobile ? "0.9rem" : "1rem" }}>
                                    Bank Transfer (T/T)
                                </Typography>
                            </Box>

                            <Typography sx={{ color: TEXT_MEDIUM, lineHeight: 1.4, fontSize: isMobile ? "0.8rem" : "0.85rem", marginBottom: "10px" }}>
                                <b>Recommended</b> for all <b>vehicle and large-value purchases</b> (T/T, SWIFT, NEFT).
                            </Typography>
                            <Box sx={{ backgroundColor: LIGHT_RED, padding: "8px", borderRadius: "6px" }}>
                                <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>
                                    Fees: Customer pays <b>all bank charges</b> (Sending, Intermediary, Receiving).
                                </Typography>
                            </Box>
                        </PaymentMethodCard>

                        {/* Online Payment Gateway */}
                        <PaymentMethodCard>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
                                <Box sx={{ 
                                    backgroundColor: PRIMARY_RED, 
                                    width: "36px", 
                                    height: "36px", 
                                    borderRadius: "50%", 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center" 
                                }}>
                                    <i className="fas fa-credit-card" style={{ color: "white", fontSize: "16px" }}></i>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: "bold", color: TEXT_DARK, fontSize: isMobile ? "0.9rem" : "1rem" }}>
                                    Online Payment Gateway
                                </Typography>
                            </Box>

                            <Typography sx={{ color: TEXT_MEDIUM, lineHeight: 1.4, fontSize: isMobile ? "0.8rem" : "0.85rem", marginBottom: "10px" }}>
                                Accepts major <b>Credit Card, Debit Card, and Netbanking</b> payments securely.
                            </Typography>
                            <Box sx={{ backgroundColor: LIGHT_RED, padding: "8px", borderRadius: "6px" }}>
                                <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>
                                    Fees: A processing fee (typically <b>3-5%</b>) is added to the invoice total.
                                </Typography>
                            </Box>
                        </PaymentMethodCard>

                        {/* PayPal */}
                        <PaymentMethodCard>
                            <Box sx={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
                                <Box sx={{ 
                                    backgroundColor: PRIMARY_RED, 
                                    width: "36px", 
                                    height: "36px", 
                                    borderRadius: "50%", 
                                    display: "flex", 
                                    alignItems: "center", 
                                    justifyContent: "center" 
                                }}>
                                    <i className="fab fa-paypal" style={{ color: "white", fontSize: "16px" }}></i>
                                </Box>
                                <Typography variant="h6" sx={{ fontWeight: "bold", color: TEXT_DARK, fontSize: isMobile ? "0.9rem" : "1rem" }}>
                                    PayPal (Limited Use)
                                </Typography>
                            </Box>

                            <Typography sx={{ color: TEXT_MEDIUM, lineHeight: 1.4, fontSize: isMobile ? "0.8rem" : "0.85rem", marginBottom: "10px" }}>
                                Accepted for <b>deposits, small orders</b>, and <b>low-value transactions only.</b>
                            </Typography>
                            <Box sx={{ backgroundColor: LIGHT_RED, padding: "8px", borderRadius: "6px" }}>
                                <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>
                                    Fees: A standard commission fee (typically <b>4-6%</b>) is added to the total.
                                </Typography>
                            </Box>
                        </PaymentMethodCard>
                    </Box>
                    
                    {/* Security Guarantee Box */}
                    <PaymentCard sx={{ borderLeft: `3px solid ${PRIMARY_RED}`, marginBottom: "30px" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "5px" }}>
                            <i className="fas fa-shield-alt" style={{ color: PRIMARY_RED, fontSize: "16px" }}></i>
                            <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.85rem" : "0.9rem" }}>
                                Security Guarantee
                            </Typography>
                        </Box>
                        <Typography sx={{ color: TEXT_MEDIUM, lineHeight: 1.5, fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                            All financial data is <b>encrypted</b> and secured according to industry standards. We <b>do not store</b> sensitive payment card information on our servers.
                        </Typography>
                    </PaymentCard>

                    {/* 2. Currency, Exchange Rates, and Bank Charges */}
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            fontWeight: "bold", 
                            color: TEXT_DARK, 
                            borderBottom: `2px solid ${LIGHT_RED}`, 
                            paddingBottom: "10px", 
                            marginTop: "20px", 
                            marginBottom: "20px",
                            fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
                        }}
                    >
                        <i className="fas fa-money-bill-wave me-2" style={{ color: PRIMARY_RED }}></i>
                        2. Currency & Bank Charges
                    </Typography>

                    <PaymentCard sx={{ marginBottom: "30px" }}>
                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: "15px" }}>
                            <Box>
                                <Typography sx={{ fontWeight: "bold", color: TEXT_DARK, fontSize: isMobile ? "0.85rem" : "0.9rem", marginBottom: "5px" }}>
                                    Primary Settlement Currency
                                </Typography>
                                <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                                    Based on the currency stated in the Pro-forma Invoice (usually <b>JPY or USD</b>).
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ fontWeight: "bold", color: TEXT_DARK, fontSize: isMobile ? "0.85rem" : "0.9rem", marginBottom: "5px" }}>
                                    Exchange Rate Risk
                                </Typography>
                                <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                                    Customer is responsible for any shortfall due to <b>exchange rate fluctuation</b> between invoice and fund clearance.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ 
                            backgroundColor: LIGHT_RED, 
                            padding: isMobile ? "10px" : "15px", 
                            borderRadius: "6px", 
                            marginTop: "15px" 
                        }}>
                            <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                                <i className="fas fa-exclamation-circle me-1"></i> Bank Charges Clarification (T/T):
                            </Typography>
                            <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.75rem" : "0.8rem", marginTop: "5px" }}>
                                You <b>must select the "OUR" option</b> (Sender pays all transfer fees) to ensure the full invoice amount arrives. Any shortfall will be immediately invoiced.
                            </Typography>
                        </Box>
                    </PaymentCard>
                    
                    {/* 3. Payment Deadlines and Pickup Policy */}
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            fontWeight: "bold", 
                            color: TEXT_DARK, 
                            borderBottom: `2px solid ${LIGHT_RED}`, 
                            paddingBottom: "10px", 
                            marginTop: "20px", 
                            marginBottom: "20px",
                            fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
                        }}
                    >
                        <i className="fas fa-calendar-alt me-2" style={{ color: PRIMARY_RED }}></i>
                        3. Payment Deadlines & Pickup Policy
                    </Typography>

                    <Box sx={{ overflowX: 'auto', marginBottom: "30px" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: isMobile ? "100%" : "650px", border: `1px solid ${LIGHT_RED}` }}>
                            <thead style={{ backgroundColor: LIGHT_RED }}>
                                <tr>
                                    <th style={{ padding: isMobile ? "8px" : "10px", textAlign: "left", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: "bold" }}>Payment Type</th>
                                    <th style={{ padding: isMobile ? "8px" : "10px", textAlign: "left", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: "bold" }}>Deadline Requirement</th>
                                    <th style={{ padding: isMobile ? "8px" : "10px", textAlign: "left", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.85rem", fontWeight: "bold" }}>Consequence for Late Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ borderBottom: `1px solid ${LIGHT_RED}` }}>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_DARK, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Auction Deposit</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_MEDIUM, fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Required <b>prior to bidding</b>.</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.8rem" }}><b>Forfeited</b> to cover cancellation fees if the balance isn't paid.</td>
                                </tr>
                                <tr style={{ borderBottom: `1px solid ${LIGHT_RED}` }}>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_DARK, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Balance Payment</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_MEDIUM, fontSize: isMobile ? "0.75rem" : "0.8rem" }}><b>100% of the Invoice</b> required within <b>five (5) business days</b> of Pro-forma Invoice receipt.</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Daily penalty fee, deposit forfeiture, and/or item re-listed.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_DARK, fontWeight: "bold", fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Shipping & Documents</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: TEXT_MEDIUM, fontSize: isMobile ? "0.75rem" : "0.8rem" }}>No goods shipped until <b>100% of the invoice amount is fully cleared</b>.</td>
                                    <td style={{ padding: isMobile ? "8px" : "10px", color: PRIMARY_RED, fontSize: isMobile ? "0.75rem" : "0.8rem" }}>Shipping delays and potential port storage fees (paid by customer).</td>
                                </tr>
                            </tbody>
                        </table>
                    </Box>
                    
                    {/* Local Pickup Policy */}
                    <PaymentCard sx={{ border: `1px solid ${PRIMARY_RED}`, backgroundColor: "#FFF7F7", marginBottom: "30px" }}>
                        <Typography sx={{ color: TEXT_DARK, fontWeight: "bold", fontSize: isMobile ? "0.85rem" : "0.9rem", marginBottom: "5px" }}>
                            <i className="fas fa-box-open me-2" style={{ color: PRIMARY_RED }}></i>
                            Local Pickup Policy
                        </Typography>
                        <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                            Accepted for parts/small goods. Pickups <b>must be scheduled in advance</b> and require <b>full payment cleared</b> before collection.
                        </Typography>
                    </PaymentCard>
                    
                    {/* 4. Wire Transfer Instructions (T/T) */}
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            fontWeight: "bold", 
                            color: TEXT_DARK, 
                            borderBottom: `2px solid ${LIGHT_RED}`, 
                            paddingBottom: "10px", 
                            marginTop: "20px", 
                            marginBottom: "20px",
                            fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
                        }}
                    >
                        <i className="fas fa-keyboard me-2" style={{ color: PRIMARY_RED }}></i>
                        4. Wire Transfer Instructions (T/T)
                    </Typography>

                    <PaymentCard sx={{ borderLeft: `3px solid ${PRIMARY_RED}` }}>
                        <Typography sx={{ color: PRIMARY_RED, fontWeight: "bold", fontSize: isMobile ? "0.85rem" : "0.9rem", marginBottom: "5px" }}>
                            <i className="fas fa-bookmark me-2"></i>
                            IMPORTANT REMARK
                        </Typography>
                        <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.8rem" : "0.85rem" }}>
                            Please ensure your bank includes the <b>Invoice Number or Chassis Number</b> in the remarks section of the transfer to ensure <b>prompt fund allocation</b>.
                        </Typography>
                        <Typography sx={{ color: TEXT_MEDIUM, fontSize: isMobile ? "0.75rem" : "0.8rem", marginTop: "10px", fontStyle: "italic" }}>
                            (Actual bank account details will be provided separately on the Pro-forma Invoice.)
                        </Typography>
                    </PaymentCard>

                </Box>
            </Box>
            
            {/* Space Filler for Footer Alignment */}
            <Box sx={{ height: isMobile ? "10px" : isTablet ? "10px" : "50px" }} />
            
            <FooterManual />
        </Box>
    );
};

export default SecurePayment;